function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import "core-js/modules/es.regexp.exec.js";
import PropTypes from "prop-types";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { EuiBadge, EuiRadioGroup, EuiSpacer, EuiSwitch, EuiPanel, EuiText, EuiTitle } from '../../../../src/components';
import { BarSeries, LineSeries, AreaSeries } from '@elastic/charts';
import euiPackage from '../../../../package.json';
var devDependencies = euiPackage.devDependencies;
export var chartsVersion = devDependencies['@elastic/charts'].match(/\d+\.\d+\.\d+/)[0];
export var CHART_COMPONENTS = {
  BarSeries: BarSeries,
  LineSeries: LineSeries,
  AreaSeries: AreaSeries
};
export var ExternalBadge = function ExternalBadge() {
  return ___EmotionJSX(EuiBadge, {
    iconType: "popout",
    iconSide: "right",
    onClickAriaLabel: "Go to @elastic/charts docs",
    onClick: function onClick() {
      return window.open("https://github.com/elastic/elastic-charts/tree/v".concat(chartsVersion));
    }
  }, "External library: @elastic/charts v", chartsVersion);
};
export var ChartCard = function ChartCard(_ref) {
  var title = _ref.title,
    description = _ref.description,
    children = _ref.children;
  return ___EmotionJSX(EuiPanel, null, ___EmotionJSX(EuiTitle, {
    size: "s"
  }, ___EmotionJSX("span", null, title)), ___EmotionJSX(EuiSpacer, {
    size: "s"
  }), description && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(EuiText, {
    size: "s"
  }, ___EmotionJSX("p", null, description)), ___EmotionJSX(EuiSpacer, {
    size: "s"
  })), children);
};
ChartCard.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node
};
export var ChartTypeCard = function ChartTypeCard(props) {
  var idPrefix = 'chartType';
  var toggleButtonsIcons = [{
    id: "".concat(idPrefix, "0"),
    label: 'BarSeries'
  }, {
    id: "".concat(idPrefix, "1"),
    label: 'LineSeries'
  }, {
    id: "".concat(idPrefix, "2"),
    label: 'AreaSeries'
  }];
  var _useState = useState("".concat(idPrefix, "0")),
    _useState2 = _slicedToArray(_useState, 2),
    toggleIdSelected = _useState2[0],
    setToggleIdSelectd = _useState2[1];
  var onChartTypeChange = function onChartTypeChange(optionId) {
    setToggleIdSelectd(optionId);
    var chartType = toggleButtonsIcons.find(function (_ref2) {
      var id = _ref2.id;
      return id === optionId;
    }).label;
    props.onChange(chartType);
  };
  if (props.mixed) {
    toggleButtonsIcons[3] = {
      id: "".concat(idPrefix, "3"),
      label: 'Mixed',
      disabled: props.mixed === 'disabled'
    };
  }
  return ___EmotionJSX(ChartCard, {
    title: "Chart types",
    description: "".concat(props.type, " charts can be displayed as any x/y series type.")
  }, ___EmotionJSX(EuiRadioGroup, {
    compressed: true,
    options: toggleButtonsIcons,
    idSelected: toggleIdSelected,
    onChange: onChartTypeChange,
    disabled: props.disabled
  }));
};
export var MultiChartCard = ({
  onChange
}) => {
  const [multi, setMulti] = useState(false);
  const [stacked, setStacked] = useState(false);
  return <ChartCard title="Single vs multiple series" description="Legends are only necessary when there are multiple series. Stacked series indicates accumulation but can hide subtle differences. Do not stack line charts.">
      <EuiSwitch label="Show multi-series" checked={multi} onChange={e => {
      const isStacked = e.target.checked ? stacked : false;
      setMulti(e.target.checked);
      setStacked(isStacked);
      onChange({
        multi: e.target.checked,
        stacked
      });
    }} />
      <EuiSpacer size="s" />
      <EuiSwitch label="Stacked" checked={stacked} onChange={e => {
      setStacked(e.target.checked);
      onChange({
        multi: multi,
        stacked: e.target.checked
      });
    }} disabled={!multi} />
    </ChartCard>;
};
MultiChartCard.propTypes = {
  onChange: PropTypes.func.isRequired
};
try {
  ChartCard.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/elastic_charts/shared.tsx',
    description: '',
    displayName: 'ChartCard',
    methods: [],
    props: {
      title: {
        defaultValue: null,
        description: '',
        name: 'title',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ReactNode'
        }
      },
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}
try {
  ChartTypeCard.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/elastic_charts/shared.tsx',
    description: '',
    displayName: 'ChartTypeCard',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      mixed: {
        defaultValue: null,
        description: '',
        name: 'mixed',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"disabled" | "enabled"',
          value: [{
            value: '"disabled"'
          }, {
            value: '"enabled"'
          }]
        }
      },
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '((chartType: "BarSeries" | "LineSeries" | "AreaSeries" | "Mixed") => void) | ((chartType: "BarSeries" | "LineSeries" | "AreaSeries") => void)'
        }
      },
      disabled: {
        defaultValue: null,
        description: '',
        name: 'disabled',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}
try {
  MultiChartCard.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/elastic_charts/shared.tsx',
    description: '',
    displayName: 'MultiChartCard',
    methods: [],
    props: {
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/elastic_charts/shared.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '({ multi, stacked }: { multi: boolean; stacked: boolean; }) => void'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}